import React from 'react';

const ProductionsDecoration = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="436"
  height="273"
  fill="none"
  viewBox="0 0 436 273"
>
  <path
    stroke="#691F20"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M395.167 316.333a39.417 39.417 0 0 1-39.417 39.417H40.417A39.417 39.417 0 0 1 1 316.333V40.417A39.416 39.416 0 0 1 40.417 1h98.541l39.417 59.125H355.75a39.417 39.417 0 0 1 39.417 39.417z"
  ></path>
  <path
    stroke="#fff"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M434.167 336.333a39.417 39.417 0 0 1-39.417 39.417H79.417A39.417 39.417 0 0 1 40 336.333V60.417A39.416 39.416 0 0 1 79.417 21h98.541l39.417 59.125H394.75a39.417 39.417 0 0 1 39.417 39.417z"
  ></path>
</svg>
);

export default ProductionsDecoration;
